<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-4.mt-3.pb-3 {{ $tf("process.list.title") }}
  v-layout(row :class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card.grey.lighten-4(width="100%")
      v-card-text(:class="{ 'px-0' : $vuetify.breakpoint.xsOnly }")
        div(v-if="startableDefinitions && startableDefinitions.length > 0")
          v-list.v-list-responsive.overflow-x-hidden.pa-0
            template(v-for='(d, index) in startableDefinitions')
              v-list-tile(:key='d.id' avatar ripple @click="selectDefinition(d)" v-if="d.key === 'NEWS-01' || d.key === 'BMA-01' || d.key === 'BMA-03' || d.key === 'BMA-04' || d.key === 'BMA-05' || d.key === 'BMA-06' || (d.key === 'BMA-02' && !isZhairemRegion) || ((d.key === 'USER-01' || d.key === 'USER-02' || d.key === 'USER-03' || d.key === 'SYSTEM-01' || d.key === 'SYSTEM-02' || d.key === 'SYSTEM-03' || d.key === 'NOTIFY-01') && isCamundaAdmin)")
                v-list-tile-avatar( color="primary")
                  i.v-icon.white--text.material-icons.process-default-icon(:class="d.key")
                v-list-tile-content.pa-2
                  v-list-tile-title {{ $tf(`${d.key}._process.name`, d.name) }}
              v-divider(inset v-if="startableDefinitions.length-1 !== index")
            v-divider(inset v-if="isBma0305Starters && (isRidderRegion || isUKRegion)")
            v-list-tile(avatar ripple @click="select" :to="{name:'Activity'}" v-if="isBma0305Starters && (isRidderRegion || isUKRegion)")
              v-list-tile-avatar( color="primary")
                i.v-icon.white--text.material-icons.process-default-icon
              v-list-tile-content.pa-2
                v-list-tile-title {{ $tf("forms.subscriptionToPool") }}
            v-divider(inset v-if="isBma0305Starters && isRidderRegion")
            v-list-tile(avatar ripple @click="select" :to="{name:'Ski'}" v-if="isBma0305Starters && isRidderRegion")
              v-list-tile-avatar( color="primary")
                i.v-icon.white--text.material-icons.process-default-icon
              v-list-tile-content.pa-2
                v-list-tile-title {{ $tf("forms.subscriptionToSki") }}

        div(v-if="startableDefinitions && startableDefinitions.length == 0")
          v-flex(xs12)
            div.nothing-right-div
              v-layout(align-center justify-center row fill-height)
                div.headline.grey--text.ta-c.px-5 {{ $tf("process.list.startProcessDenied") }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import lodash from 'lodash'

export default {
  name: 'ProcessList',

  data() {
    return {
      isAltayRegion: false,
      isUKRegion: false,
      isRidderRegion: false,
      isZhairemRegion: false
    }
  },

  computed: {
    ...mapGetters({
      startableDefinitions: 'process/startableDefinitions',
      profile: 'auth/profile',
      groups: 'auth/groups',
    }),
    employees(){
      return this.$store.getters['data/employees'];
    },
    isBma0305Starters() {
      return lodash.some(this.groups, group => group.id == 'bma_03_06_starters');
    },
    isCamundaAdmin() {
      return lodash.some(this.groups, group => group.id == 'camunda-admin');
    }
  },

  created() {
    this.getDefinitions()
    this.search(this.profile.userName);
  },

  methods: {
    ...mapActions({
      getDefinitions: 'process/getDefinitions',
    }),

    selectDefinition(d) {
      this.$router.push({ name: 'ProcessStartController', params: { definitionId: d.id } })
    },

    search(iin){
      return this.$store.dispatch('data/getUser', iin)
    },
    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },

  watch: {
    'employees'(employees) {
      if(this.employees.length > 0){
        if(this.employees[0].data){
          let data = this.employees[0].data;
          if(data.region){
            this.isAltayRegion = (data.region.id === 'altay');
            this.isUKRegion = (data.region.id === 'oskemen');
            this.isRidderRegion = (data.region.id === 'ridder') || (this.profile.userName === '830501301242');
            this.isZhairemRegion = (data.region.id === 'zhairem');
            this.isKokshetauRegion = (data.region.id === 'kokshetau');
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/components/process/ProcessList.vue